import { apiClient } from '@shared/utils/api-client';
import axiosInstance from '@shared/utils/axios-instance';
import type {
  AdvertisingInvoiceRow,
  AdvertisingRefundRow,
  SellerAdvertisingCredit,
  SellerLedgerResponse,
  SellerPromotionBudgetUpdateResult,
  SellerUpdDocumentRow,
} from '../types';

export const sellerFinanceApi = {
  getMyUpdDocuments: () =>
    apiClient.get<SellerUpdDocumentRow[]>('/seller-finance/me/upd-documents'),

  getMyLedger: () =>
    apiClient.get<SellerLedgerResponse>('/seller-finance/me/ledger'),

  getMyAdvertisingCredit: () =>
    apiClient.get<SellerAdvertisingCredit>(
      '/seller-finance/me/advertising-credit',
    ),

  transferAdvertisingFromPayable: (amountRub: number) =>
    apiClient.post(
      '/seller-finance/me/advertising-wallet/transfer-from-payable',
      { amountRub },
    ),

  returnAdvertisingToPayable: (amountRub: number) =>
    apiClient.post(
      '/seller-finance/me/advertising-wallet/return-to-payable',
      { amountRub },
    ),

  issueAdvertisingInvoice: (amountRub: number) =>
    apiClient.post<AdvertisingInvoiceRow>('/seller-finance/me/advertising-invoices', {
      amountRub,
    }),

  cancelAdvertisingInvoice: (id: number) =>
    apiClient.post<AdvertisingInvoiceRow>(
      `/seller-finance/me/advertising-invoices/${id}/cancel`,
    ),

  downloadAdvertisingInvoicePdf: async (invoiceId: number): Promise<Blob> => {
    const response = await axiosInstance.get(
      `/seller-finance/me/advertising-invoices/${invoiceId}/pdf`,
      { responseType: 'blob' },
    );
    return response.data as Blob;
  },

  mockPayAdvertisingInvoice: (id: number) =>
    apiClient.post<{ credited: true }>(
      `/seller-finance/me/advertising-invoices/${id}/mock-pay`,
    ),

  requestAdvertisingRefund: (amountRub: number) =>
    apiClient.post<AdvertisingRefundRow>('/seller-finance/me/advertising-refunds', {
      amountRub,
    }),

  updateMyPromotionBudget: (weeklyBudgetRub: number | null) =>
    apiClient.patch<SellerPromotionBudgetUpdateResult>(
      '/seller-finance/me/promotion-budget',
      { weeklyBudgetRub },
    ),

  /** Скачивание PDF акта или счёта-фактуры. */
  downloadPdfBlob: async (
    documentId: number,
    kind: 'act' | 'invoice' = 'act',
  ): Promise<Blob> => {
    const response = await axiosInstance.get(
      `/seller-finance/me/upd-documents/${documentId}/pdf`,
      {
        params: { kind },
        responseType: 'blob',
        maxRedirects: 5,
      },
    );
    return response.data as Blob;
  },
};
